import { connectRouter } from 'connected-react-router';
import { combineReducers } from 'redux';

import IAMReducer from './IAMReducer';
import UIReducer from './UIReducer';
import AppReducer from './AppReducer';

const createRootReducer = (history) => combineReducers({
    router: connectRouter(history),
    ui: UIReducer,
    iam: IAMReducer,
    app: AppReducer,
})

export default createRootReducer;
